import { getDefaultSSEHeaders } from '../../Config/SSE/sse.config'
import { SSEResponse } from './sse.types'

export const fetchSSEStream = async (
  url: string,
  headers: Record<string, string>,
  signal: AbortSignal
): Promise<SSEResponse> => {
  console.log('Initiating SSE fetch request...')

  const defaultHeaders = getDefaultSSEHeaders()

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: { ...defaultHeaders, ...headers },
      signal,
      mode: 'cors',
    })

    console.log('SSE Response received')
    console.log('SSE Response status:', response.status)
    console.log('SSE Response status text:', response.statusText)

    if (!response.ok) {
      const responseText = await response.text()
      console.error('SSE Error Response Body:', responseText)
      throw new Error(
        `SSE Connection Failed - Status: ${response.status} ${response.statusText}`
      )
    }

    const contentType = response.headers.get('content-type')
    console.log('SSE Content-Type:', contentType)

    if (
      !contentType?.includes('text/event-stream') &&
      !contentType?.includes('application/stream+json')
    ) {
      console.warn('Unexpected content type:', contentType)
    }

    if (!response.body) {
      throw new Error('Response body is null - SSE not supported by endpoint')
    }

    const reader = response.body.getReader()
    if (!reader) {
      throw new Error('ReadableStream not supported in this browser.')
    }

    return { response, reader }
  } catch (err) {
    // If the error is an AbortError, rethrow it to be handled by the caller
    if (err instanceof Error && err.name === 'AbortError') {
      throw err
    }
    // Otherwise, wrap it in a more descriptive error
    throw new Error(
      `Failed to establish SSE connection: ${
        err instanceof Error ? err.message : 'Unknown error'
      }`
    )
  }
}
